import { Component, OnInit } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { dropdownConfig } from '@core/configs/dropdown-tabs.configs';
import { DropdownTabsModel } from '@core/models/dropdown-tabs.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-dropdown-tabs',
  templateUrl: './dropdown-tabs.component.html',
  styleUrls: ['./dropdown-tabs.component.scss']
})
export class DropdownTabsComponent implements OnInit {

  public dropdownConfig: DropdownTabsModel;
  public baseURL: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.dropdownConfig = dropdownConfig;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.baseURL = event.url.split("/")[1];
      }
    })
  }

  navigate(route: string): void {
    this.router.navigateByUrl(route);
  }

}
